import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19.6 10A9.6 9.6 0 1 1 .4 10a9.6 9.6 0 0 1 19.2 0ZM10 6.4a1.2 1.2 0 0 0-1.04.6 1.2 1.2 0 1 1-2.078-1.2 3.6 3.6 0 1 1 4.318 5.196v.204a1.2 1.2 0 1 1-2.4 0V10A1.2 1.2 0 0 1 10 8.8a1.2 1.2 0 1 0 0-2.4Zm0 9.6a1.2 1.2 0 1 0 0-2.399 1.2 1.2 0 0 0 0 2.4Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }